import { Typography } from "@mui/material";

export default function BlogComponent() {
  return (
    <div>
      <Typography>Hello Blog Page</Typography>
    </div>
  );
}
